webpackJsonp([105115349511802],{

/***/ 1336:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":{"edges":[{"node":{"title":"Making The Transition from Software Engineer To Manager ","metaDescription":"Looking for resources as you learn to code? The Code Fellows blog features helpful tutorials, alumni stories, student projects, school news, and more!","slug":"blog/making-the-transition-from-software-engineer-to-manager","createdAt":"2017-09-27T18:30:03.503Z","blogAuthor":{"fields":{"name":"Daryl Thayil","slug":"blog/author/daryl-thayil"}},"imageHeader":{"fields":{"file":{"url":"//images.ctfassets.net/k428n7s2pxlu/37dpqAlRagmEG2uQMGSKIQ/667b5e86896c824ba0897d2f7433b1c1/blog-post-blog-making-the-transition-from-software-engineer-to-manager.jpg"}}}}}]},"authorJson":{"name":"Daryl Thayil","slug":"blog/author/daryl-thayil","twitter":null,"linkedIn":null,"website":null,"biography":null,"image":null}},"pathContext":{"slug":"blog/author/daryl-thayil"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-daryl-thayil-a7565cd53cbdbc4a4dd0.js